export default __webpack_public_path__ + "static-front/media/PrinterIcon.2b7815c2.svg";